import { VFC } from 'react';
import Title from 'antd/lib/typography/Title';
import { useNavigate } from 'react-router-dom';
import { MeterIdentificationWorkflow } from 'routes/meter_identification/constants';
import { FormattedMessage } from 'react-intl';
import { Layout } from '../../components/Layout/Layout';
import { Button } from '../../components/Button/Button';
import { FullWidthHeightSpace } from '../../components/Space/FullWidthHeightSpace';
import { CrossroadPageMessages as messages } from './messages';

export const CrossroadPage: VFC = () => {
  const navigate = useNavigate();

  return (
    <Layout headerContent={<FormattedMessage {...messages.headerContent} />}>
      <FullWidthHeightSpace align="center" direction="vertical">
        <Title level={4} style={{ textAlign: 'center' }}>
          <FormattedMessage {...messages.title} />
        </Title>
        <Button block onClick={() => navigate('meter-identification')}>
          <FormattedMessage {...messages.meterIdentification} />
        </Button>
        <Button block onClick={() => navigate('inventorize')}>
          <FormattedMessage {...messages.meterPasport} />
        </Button>
        <Button
          block
          onClick={() =>
            navigate('meter-identification', { state: { workflow: MeterIdentificationWorkflow.SensorInstallation } })
          }
        >
          <FormattedMessage {...messages.sensorInstallation} />
        </Button>
        <Button
          block
          onClick={() =>
            navigate('meter-identification', { state: { workflow: MeterIdentificationWorkflow.MeterReplacement } })
          }
        >
          <FormattedMessage {...messages.meterReplacement} />
        </Button>
        <Button
          block
          onClick={() =>
            navigate('meter-identification', { state: { workflow: MeterIdentificationWorkflow.ServiceInspection } })
          }
        >
          <FormattedMessage {...messages.serviceInspection} />
        </Button>
        <Button block onClick={() => navigate('meters-list')}>
          <FormattedMessage {...messages.meterList} />
        </Button>
        <Button block onClick={() => navigate('reading-groups')}>
          <FormattedMessage {...messages.readingGroups} />
        </Button>
      </FullWidthHeightSpace>
    </Layout>
  );
};
